import { render, staticRenderFns } from "./FavoriteRoles.vue?vue&type=template&id=4dd5da08&scoped=true&"
import script from "./FavoriteRoles.vue?vue&type=script&lang=js&"
export * from "./FavoriteRoles.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteRoles.vue?vue&type=style&index=0&id=4dd5da08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5da08",
  null
  
)

export default component.exports